
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tag.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-weet-tag-demo-basic","docs-weet-tag-demo-close","docs-weet-tag-demo-click","docs-weet-tag-demo-size","docs-weet-tag-demo-color","docs-weet-tag-demo-avatar","docs-weet-tag-demo-status"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/weet-components/site/docs/weet/tag.md?type=demo')
};